import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaCheck } from "react-icons/fa6"; 
import Navbar from "../components/Navbar";
import notFound from "../img/not-found.png";
import "./RegistroEnviado.css";


const NotFound = () => {

  const { role, isAuthenticated } = useSelector((state) => state.auth);

  return (
    <>
      <Navbar />

      <main className="not-found align-center gap-50 fixed">

        <img src={notFound} alt="Dibujo de unsa persona y un CV"/>

        <section className="column ">
            <p className="numero bold">404</p>
            <div className="texto column gap-5 mb-10">
                <p className="ups mb-10">Ups... </p>
                <p>No has podido encontrar esta página, <br></br>pero sí puedes encontrar oportunidades.</p>
                <p className="bold">¡Estamos aquí para ayudarte!</p>
            </div>
            
            {!isAuthenticated && ( 
              <Link to="/" className="verde">Volver a la Landing page</Link>
            )}
        </section>
        
      </main>
    </>
  );
};

export default NotFound;